export const finanzcoachingFAQData = [
  {
    question: "Was genau ist Finanzcoaching?",
    answer: "Finanzcoaching ist persönliche Entwicklung rund um Geld. Als Coach unterstütze ich Sie dabei, eigene finanzielle Entscheidungen zu treffen und finanzielle Selbstbestimmung zu erlangen - ohne Produktverkauf."
  },
  {
    question: "Wie unterscheidet sich Finanzcoaching von Finanzberatung?",
    answer: "Finanzcoaching macht Sie finanziell selbstbestimmt, während Finanzberatung oft produktbezogen ist. Ich verkaufe keine Finanzprodukte, sondern befähige Sie zu eigenen Entscheidungen."
  },
  {
    question: "Arbeiten Sie mit Geld-Glaubenssätzen?",
    answer: "Ja, limitierende Glaubenssätze über Geld sind oft der Grund für finanzielle Probleme. Wir identifizieren und transformieren diese gemeinsam für nachhaltige Veränderung."
  },
  {
    question: "Kann mir Finanzcoaching bei Schulden helfen?",
    answer: "Finanzcoaching kann bei der Entwicklung einer Strategie zum Schuldenabbau helfen und das Bewusstsein für Ausgabenmuster schärfen. Bei konkreten Rechtsthemen verweise ich an Fachexperten."
  },
  {
    question: "Wie wird finanzielle Intelligenz entwickelt?",
    answer: "Durch praktisches Finanzwissen, Reflexion des eigenen Verhaltens und schrittweise Umsetzung neuer Gewohnheiten. Ziel ist Ihre langfristige finanzielle Unabhängigkeit."
  }
];